import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { NavigationStart, Params, Router } from '@angular/router';
import { PartnerService } from './partner.service';
import { AuthGuardService } from './auth-guard.service';
import { firstValueFrom, tap } from 'rxjs';
import { APP_CONFIG } from '../../../tockens';
@Injectable(
    { providedIn: 'root' }
)
export class ConfigService {
    params: Params = {};
    recaptchaSiteKeyV3: string | null = null;

    config: any;

    constructor(
        protected partnerService: PartnerService,
        protected guard: AuthGuardService,
        @Inject(DOCUMENT) protected document: any,
        @Inject(APP_CONFIG) protected appConfig: any,
        private router: Router) { }

    async loadConfig() {
        const siteKeyV3 = await this.guard.getrecapchekey();
        this.recaptchaSiteKeyV3 = siteKeyV3;
    }

    init(): Promise<any> {
        return firstValueFrom(this.router.events
            .pipe(
                tap((event) => {
                    // console.log(event)
                    if (event instanceof NavigationStart) {
                        // // Could add more chars url:path?=;other possible
                        
                        const urlDelimitators = new RegExp(/[?//,;&:#$+=]/);
                        const currentUrlPath = event.url.slice(1).split(urlDelimitators)[0];
                        // console.log(currentUrlPath)
                        this.guard.checkPartner(currentUrlPath);
                    }
                })
            ));
    }

    font(): Promise<any> {
        return this.document.fonts.ready.then(() => { });
    }

    getConfig() {
        return this.appConfig;
    }
}
